export const userStatusMappings = {
  enabled: 'active',
  disabled: 'disabled',
  invited: 'invited',
};
